import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChangelog = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 5,
			width: 3,
			height: 3,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 13,
			width: 3,
			height: 3,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 5,
			width: 11,
			height: 2,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 13,
			width: 11,
			height: 2,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .4,
			x: 9,
			y: 9,
			width: 7,
			height: 2,
			rx: 1,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .4,
			x: 9,
			y: 17,
			width: 7,
			height: 2,
			rx: 1,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgChangelog);
export { ForwardRef as ReactComponent };
